"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOpenidConfiguration = exports.SET_OPENID_CONFIGURATION = void 0;

var _getActionName = require("skybase-ui/skybase-core/utils/get-action-name");

var _createAction = require("skybase-ui/skybase-core/base/create-action");

var _constants = require("../constants");

var SET_OPENID_CONFIGURATION = (0, _getActionName.getActionName)('SET_OPENID_CONFIGURATION', _constants.MODULE_NAME);
exports.SET_OPENID_CONFIGURATION = SET_OPENID_CONFIGURATION;

var setOpenidConfiguration = function setOpenidConfiguration(config) {
  return (0, _createAction.createAction)(SET_OPENID_CONFIGURATION, {
    config: config
  });
};

exports.setOpenidConfiguration = setOpenidConfiguration;
//# sourceMappingURL=actions.js.map